import { call, put, select, takeLatest } from 'redux-saga/effects';

import { addCustomGTMEvent } from '../../../events/googleTagManager';
import { formatError } from '../../../libs';
import searchAPI from '../../api/search';
import { Creators, Types } from '../../reducers/search';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* searchInfosRequest({ products: offers }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const token = yield select(getToken);

    const id = offers?.map(({ product }) => product?.id).join(',');

    const data = yield call(searchAPI.searchProductsInformations, { id }, siteId, token);

    const loadedData = data.map((item) => ({ ...item, loaded: true }));
    addCustomGTMEvent({
      event: 'success_view_search_results_dropdown',
      data: {
        items: loadedData.map((item, index) => ({
          item_id: item.id,
          item_name: item.name,
          price: item.salesPrice?.value,
          affiliation: item?.seller?.name,
          index,
        })),
      },
    });

    yield put(Creators.searchInfosSuccess(loadedData));
  } catch (error) {
    yield put(Creators.searchFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SEARCH_INFOS_REQUEST, searchInfosRequest);
}
